export const ACCOUNTS_WITH_SIGNALS_COLUMN = "accountsWithSignalsCount";

export const LIST_NAME_COLUMN = "listName";
